// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-selector__carousel{min-height:400px}`, "",{"version":3,"sources":["webpack://./src/react/containers/CarouselsDisplay/components/ContentsCarouselContainer/components/PlanOfferCarousel/styles.scss"],"names":[],"mappings":"AAAA,yBACE,gBAAA","sourcesContent":[".plan-selector__carousel {\n  min-height: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
